import dotPropImmutable from 'dot-prop-immutable';
import { uniqBy } from 'lodash';
import { deleteTemplateFromIndexedDb } from 'hooks/use-idb';
import { floatUid } from 'utils/uid';
export const spaceSlice = {
    setupSpacesOnProjectTemplate: (state, { payload })=>{
        const result = dotPropImmutable.merge(state, `data.${state.activeId}.spaceList`, payload);
        const spaceListIds = Object.keys(dotPropImmutable.get(result, `data.${state.activeId}.spaceList`, {}));
        return dotPropImmutable.set(result, `data.${state.activeId}.template.templateContent.spaceList`, spaceListIds);
    },
    setupSpacesOnProjectTemplateInProgress: (state)=>{
        return dotPropImmutable.set(state, `data.${state.activeId}.spaceSetup`, 'IN_PROGRESS');
    },
    setupSpacesOnProjectTemplateComplete: (state)=>{
        return dotPropImmutable.set(state, `data.${state.activeId}.spaceSetup`, 'COMPLETE');
    },
    createProjectTemplateSpace: (state, { payload })=>{
        const spaceId = floatUid();
        const spaceList = {
            [spaceId]: {
                isNew: true,
                spaceId,
                spaceName: '',
                spaceTabs: [],
                private: payload.private
            }
        };
        const result = dotPropImmutable.merge(state, `data.${state.activeId}.spaceList`, spaceList);
        const spaceListIds = Object.keys(dotPropImmutable.get(result, `data.${state.activeId}.spaceList`, {}));
        return dotPropImmutable.set(result, `data.${state.activeId}.template.templateContent.spaceList`, spaceListIds);
    },
    updateProjectTemplateSpace: (state, { payload })=>{
        const path = `data.${state.activeId}.spaceList.${payload.spaceId}`;
        const result = {
            ...state,
            ...dotPropImmutable.delete(state, `${path}.isNew`)
        };
        return dotPropImmutable.merge(result, path, payload);
    },
    deleteProjectTemplateSpace: (state, { payload })=>{
        const path = `data.${state.activeId}.spaceList.${payload.spaceId}`;
        let result = {
            ...state,
            ...dotPropImmutable.delete(state, path)
        };
        const spaceListIds = Object.keys(result.data[state.activeId].spaceList);
        result = dotPropImmutable.set(result, `data.${state.activeId}.template.templateContent.spaceList`, spaceListIds);
        return result;
    },
    deleteProjectTemplateSpaceTab: (state, { payload: { spaceTabId, spaceId } })=>{
        // If not specified, default to the active space
        spaceId !== null && spaceId !== void 0 ? spaceId : spaceId = dotPropImmutable.get(state, 'activeSpaceId', null);
        if (spaceId == null) {
            return state;
        }
        const path = `data.${state.activeId}.spaceList.${spaceId}.spaceTabs`;
        let spaceTabs = dotPropImmutable.get(state, path, []);
        spaceTabs = spaceTabs.filter((tab)=>tab.spaceTabId !== spaceTabId);
        deleteTemplateFromIndexedDb([
            spaceTabId
        ]);
        return dotPropImmutable.set(state, path, spaceTabs);
    },
    setupSpaceTabsOnSpaces: (state, { payload: { spaceTab, spaceId } })=>{
        var _ref;
        const spaceList = dotPropImmutable.get(state, `data.${state.activeId}.template.templateContent.spaceList`, []);
        const updateSpaceList = dotPropImmutable.set(state, `data.${state.activeId}.template.templateContent.spaceList`, uniqBy((spaceList !== null && spaceList !== void 0 ? spaceList : []).concat(spaceId), (x)=>x.toString()));
        const spaceDetail = dotPropImmutable.get(state, `data.${state.activeId}.spaceList.${spaceId}`, null);
        const updatedSpaceMeta = dotPropImmutable.merge(updateSpaceList, `data.${state.activeId}.spaceList.${spaceId}`, {
            spaceId,
            spaceName: (_ref = spaceDetail === null || spaceDetail === void 0 ? void 0 : spaceDetail.spaceName) !== null && _ref !== void 0 ? _ref : 'Untitled'
        });
        return dotPropImmutable.merge(updatedSpaceMeta, `data.${state.activeId}.spaceList.${spaceId}.spaceTabs`, [
            spaceTab
        ]);
    },
    updateSpaceTabInSpaces: (state, { payload: { spaceId, spaceTab } })=>{
        const path = `data.${state.activeId}.spaceList.${spaceId}.spaceTabs`;
        const spaceTabs = dotPropImmutable.get(state, path, []);
        const updatedSpaceTabs = spaceTabs.map((_spaceTab)=>{
            return _spaceTab.spaceTabId === spaceTab.spaceTabId ? spaceTab : _spaceTab;
        });
        return dotPropImmutable.set(state, path, updatedSpaceTabs);
    },
    setupActiveSpace: (state, { payload: { spaceId } })=>{
        return dotPropImmutable.set(state, 'activeSpaceId', spaceId);
    },
    setupActiveSpaceTab: (state, { payload: { spaceTabId } })=>{
        return dotPropImmutable.set(state, 'activeSpaceTabId', spaceTabId);
    }
};
